import * as React from "react";
import shopify_logo from "../../../images/shopify_glyph.png";


export class ShopifyConnectButton extends React.Component {

    render() {
        return <button className="btn shopify" onClick={this.props.onClick} disabled={this.props.disabled}>{this.renderShopifyLogo()}Conectar a Shopify</button>
    }

    getImage() {
        return shopify_logo;
    }

    renderShopifyLogo() {
        return <img alt="Shopify" src={this.getImage()} height={30} width={30} hspace={10} vspace={10}/>
    }
}
